import React from 'react';
import styled from 'styled-components';

import { colors, media } from '../../../core';

const sizes = ['70px', '50px', '36px', '30px', '24px', '20px', '16px'];
const mobileSizes = ['50px', '36px', '30px', '24px', '20px', '18px', '14px'];

export interface HeadingProps {
  size?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  smallCaps: boolean;
  color?: string;
  noMargin: boolean;
  as?: any;
  children?: any;
  weight?: string;
  noWrap?: boolean;
}

const HeadingBase = ({
  size,
  as: Component = `h${size && size <= 6 ? size : 6}`,
  ...props
}: any) => {
  return <Component {...props} />;
};

const Heading = styled(HeadingBase)<HeadingProps>`
  color: ${({ color, theme }) => color || theme.fontColor || colors.charcoal};
  font-family: ${({ theme, size }) =>
    size > 3 ? theme.fontFamily : theme.headingFontFamily || `Quicksand, san-serif`};
  font-size: ${({ size, theme }) => theme.headingSizes[(size || 4) - 1] || sizes[(size || 4) - 1]};
  font-weight: ${({ weight, theme }) => weight || theme.headingFontWeight || '700'};
  line-height: ${({ size, theme }) => theme.headingLineHeight[(size || 4) - 1] || 1.1};
  margin: ${({ noMargin = false }) => (noMargin ? 0 : '0 0 16px')};
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'wrap')};

  ${media.tabletPortrait} {
    margin: ${({ noMargin = false }) => (noMargin ? 0 : '0 0 8px')};
    font-size: ${({ size, theme }) =>
      theme.headingMobileSizes[(size || 4) - 1] || mobileSizes[(size || 4) - 1]};
  }

  ${({ smallCaps = false, theme }) =>
    smallCaps &&
    `
      letter-spacing: 0.5px;
      font-size: ${theme.headingOutline || `12px`};
      line-height: ${theme.headingOutlineLineHeight || `1.1`};
      text-transform: uppercase;
      font-family: ${theme.fontFamily};

      ${media.tabletPortrait} {
        font-size: ${theme.headingOutline || `12px`};
      }
    `}
`;

export default Heading;
